module.exports = __webpack_public_path__ + "img/mastercard.af758dde.svg";